import api from '@/api'
const state = {
	isFromIndexMap: false,
	krp: null,
	sceneList: [],
	sceneListCompare: [],
	worksDetail: {},
	materialId: '',
	isShowSceneBar: true,//场景导航条
	isShowIntro: true,//显示介绍
	commentList: [],
	commentListPage:1,
	commentListData:{},
	commentListTotal:0,
	groupList:[],
	activeGroupId:'',
	activeGroupIdCompare:'',
	isSplitScreen:false,
	sceneDataCompare:null
};

const mutations = {
	UPDATE_FROM_INDEX_MAP(state, value) {
		state.isFromIndexMap = value;
	},
	UPDATE_KRP(state, value) {
		state.krp = value;
	},
	UPDATE_SCENE_LIST(state, value) {
		state.sceneList = value;
	},
	UPDATE_MATERIAL_ID(state, value) {
		state.materialId = value;
	},
	UPDATE_SCENE_BAR(state, value) {
		state.isShowSceneBar = value;
	},
	UPDATE_SHOW_INTRO(state, value) {
		state.isShowIntro = value;
	},
	UPDATE_WORKS_DETAIL(state, value) {
		state.worksDetail = value;
	},
	UPDATE_COMMENT_LIST(state, value) {
		state.commentList = value;
	},
	UPDATE_COMMENT_LIST_DATA(state, value) {
		state.commentListData = value;
	},
	UPDATE_COMMENT_LIST_PAGE(state, value) {
		state.commentListPage = value;
	},
	UPDATE_COMMENT_LIST_TOTAL(state, value) {
		state.commentListTotal = value;
	},
	UPDATE_GROUP_LIST(state, value) {
		state.groupList = value;
	},
	UPDATE_ACTIVE_GROUP_ID(state, value) {
		state.activeGroupId = value;
	},
	UPDATE_ACTIVE_GROUP_ID_COMPARE(state, value) {
		state.activeGroupIdCompare = value;
	},
	UPDATE_IS_SPLIT_SCREEN(state, value) {
		state.isSplitScreen = value;
	},
	UPDATE_SCENE_LIST_COMPARE(state, value) {
		state.sceneListCompare = value;
	},
	
	UPDATE_SCENE_DATA_COMPARE(state, value) {
		state.sceneDataCompare = value;
	},
};

const actions = {
	
	async getGroupList(context, worksId){
		try{
			let res = await api.group.listsAll({worksId});
			context.commit("UPDATE_GROUP_LIST", res.data);
			context.commit("UPDATE_ACTIVE_GROUP_ID", res.data[0].id);
			return res.data;
		}catch (e) {
			console.error(e)
		}
	},
	
	async getWorksDetail({ commit },{worksId,groupId,noUpdate}) {
		try {
			let res = await api.works.getWorksDetail({
				worksId,
				groupId
			});
			if(!noUpdate){
				commit('UPDATE_WORKS_DETAIL', res.data)
			}
			return res.data
		} catch (e) {
			return e
		}
	},
	async getCommentList({ commit, state }, { worksId, page = 1, pageSize = 10 }) {
		this.loading = true;
		try {
			let user = localStorage.getItem("v-comment-user");
			let {lid} = user ? JSON.parse(user) : {lid:''}
			let res = await api.comment.lists({
				worksId,
				page,
				pageSize,
				lid
			});
			let lists = page === 1 ? res.data.data : state.commentList.concat(res.data.data);
			commit('UPDATE_COMMENT_LIST',lists);
			commit('UPDATE_COMMENT_LIST_PAGE',page);
			commit('UPDATE_COMMENT_LIST_DATA',res.data);
			commit('UPDATE_COMMENT_LIST_TOTAL',res.data.total);
		} catch (e) {
			console.error(e);
		}
		this.loading = false;
	},

};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
